module.exports = __webpack_public_path__ + "static/img/Group@2x-3.a6e5774c.png";